<div class="relative">
  <!-- Mobile: single globe icon -->
  <button
    type="button"
    data-testid="lang-switcher-mobile"
    class="md:hidden flex items-center justify-center w-9 h-9 rounded-lg border border-border text-content-secondary hover:text-content hover:border-border-strong hover:bg-surface-raised transition-all duration-150 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
    (click)="toggleOpen()"
  >
    <lib-icon icon="globe-alt" class="block w-5 h-5" />
  </button>

  <!-- Desktop: globe + lang code + chevron -->
  <button
    type="button"
    data-testid="lang-switcher-desktop"
    class="hidden md:flex items-center gap-2 px-2 py-0.5 rounded-lg border border-border text-content hover:text-content hover:border-border-strong hover:bg-surface-raised transition-all duration-150 cursor-pointer focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-primary"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-haspopup]="true"
    (click)="toggleOpen()"
  >
    <lib-icon icon="globe-alt" class="w-5 h-5 shrink-0" />
    <span data-testid="lang-switcher-current-code" class="text-xs font-semibold uppercase tracking-wide">{{ lang() }}</span>
    <lib-icon
      icon="chevron-right"
      class="w-3 h-3 shrink-0 transition-transform duration-150"
      [style.transform]="isOpen() ? 'rotate(120deg)' : 'rotate(90deg)'"
    />
  </button>

  @if (isOpen()) {
  <div data-testid="lang-switcher-menu" class="absolute right-0 mt-1.5 min-w-40 rounded-xl border border-border bg-surface shadow-lg overflow-hidden z-50" role="menu">
    @for (option of languages; track option.code) {
    <button
      type="button"
      [attr.data-testid]="'lang-option-' + option.code"
      class="flex w-full items-center gap-3 px-4 py-3 text-sm text-content-secondary hover:bg-surface-raised hover:text-content transition-colors duration-100 cursor-pointer focus-visible:outline-none focus-visible:bg-surface-overlay"
      [class.bg-primary-subtle]="lang() === option.code"
      [class.text-content]="lang() === option.code"
      [class.font-semibold]="lang() === option.code"
      [attr.aria-current]="lang() === option.code ? 'true' : null"
      role="menuitem"
      (click)="selectLang(option.code)"
    >
      <span class="text-base leading-none" aria-hidden="true">{{ option.flag }}</span>
      <span class="flex-1 text-left">{{ option.label }}</span>
      @if (lang() === option.code) {
      <lib-icon icon="check" class="w-3.5 h-3.5 text-primary shrink-0" />
      }
    </button>
    }
  </div>
  }
</div>
